import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import EditIcon from '../../../../../../../../components/icons/EditIcon';
import { capitalize } from '../../../../../../../../util/text';
import { EVENT_SETTING_ANNIVERSARY } from '../../../../../../../../constants/album-folder';

const propTypes = {
  values: PropTypes.shape({
    relationship: PropTypes.string,
  }),
  onUpdate: PropTypes.func,
};

const AnniversaryEventReviewDetails = ({ values, onUpdate }) => {
  return (
    <>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Type of anniversary</h3>
              <p className="text-base">{capitalize(values.anniversary_type)}</p>
            </div>
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onUpdate}
              className="ml-auto review-step-edit-icon"
            >
              <EditIcon color="#0d84fe" size="22px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>

      {values.anniversary_type === EVENT_SETTING_ANNIVERSARY.WEDDING && (
        <>
          <tr>
            <td className="text-left">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column mr-1">
                  <h3 className="mb-0">Husband &amp; Wife</h3>
                  <p className="text-base">
                    {values.groom_name} &amp; {values.bride_name}
                  </p>
                </div>
                <Button
                  btnStyle="link"
                  btnSize="sm"
                  onClick={onUpdate}
                  className="ml-auto review-step-edit-icon"
                >
                  <EditIcon color="#0d84fe" size="22px" className="ml-1" />
                </Button>
              </div>
            </td>
          </tr>
        </>
      )}
      {values.anniversary_type === EVENT_SETTING_ANNIVERSARY.WORK && (
        <>
          <tr>
            <td className="text-left">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column mr-1">
                  <h3 className="mb-0">Name of celebrated</h3>
                  <p className="text-base">
                    {values.first_name} {values.last_name}
                  </p>
                </div>
                <Button
                  btnStyle="link"
                  btnSize="sm"
                  onClick={onUpdate}
                  className="ml-auto review-step-edit-icon"
                >
                  <EditIcon color="#0d84fe" size="22px" className="ml-1" />
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td className="text-left">
              <div className="d-flex align-items-center">
                <div className="d-flex flex-column mr-1">
                  <h3 className="mb-0">Work start year</h3>
                  <p className="text-base">{values.work_start_year}</p>
                </div>
                <Button
                  btnStyle="link"
                  btnSize="sm"
                  onClick={onUpdate}
                  className="ml-auto review-step-edit-icon"
                >
                  <EditIcon color="#0d84fe" size="22px" className="ml-1" />
                </Button>
              </div>
            </td>
          </tr>
        </>
      )}
    </>
  );
};

AnniversaryEventReviewDetails.propTypes = propTypes;

export default AnniversaryEventReviewDetails;
